import React from 'react';
import styled from '@benzinga/themetron';

export interface NewsContainerProps {
  title: string;
}

export const NewsContainer: React.FC<React.PropsWithChildren<NewsContainerProps>> = ({ children, title }) => {
  return (
    <Container className="news-container">
      <TitleContainer className="title-container">
        <h3>{title}</h3>
      </TitleContainer>
      <div className="content-container">{children}</div>
    </Container>
  );
};

const TitleContainer = styled.div`
  background-color: #2d425f;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  padding: 5px 15px;
  text-transform: uppercase;

  h3 {
    color: #ffffff;
  }
`;

const Container = styled.div`
  &.news-container {
    background-color: ${({ theme }) => theme.colors.background};
    border-radius: ${({ theme }) => theme.borderRadius.default};
    border: 1px solid ${({ theme }) => theme.colors.border};
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .content-container {
      padding: 10px 15px;
    }

    .load-more-button {
      margin-bottom: 0;
      padding-bottom: 5px;
    }

    .content-feed-list {
      overflow-y: auto;
      gap: 0.3rem;
      max-height: 325px;
    }
    .title-container {
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
    }
  }
`;
